<template>
  <div>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.id"/>
      </div>
    </modal>
    <div class="container">
      <div class="cart-table-container wishlist-table-container" v-if="wishlist.length">
        <table class="table table-cart">
          <thead>
            <tr>
              <th class="product-col">Proizvod</th>
              <th>{{ translations.forms.labels.code }}</th>
              <th v-if="canViewPrices" class="price-col">{{ translations.price }}</th>
              <th class="qty-col">{{ translations.actions }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="product-row" v-for="item in wishlist" :key="item.id">
              <td class="product-col">
                <figure class="product-image-container">
                  <router-link
                    class="product-image"
                    :to="{
                      name: 'Article', params: { id: item.articleId, slug: slugify(item.title) }
                    }"
                  >
                    <Photo :src="`${baseUrl}${item.imageUrl}`" v-if="item.imageUrl" />
                    <Photo src="assets/images/no-image.jpg" v-else />
                  </router-link>
                  <a
                    class="btn-remove icon-cancel"
                    title="Ukloni proizvod"
                    @click.prevent="toggleWishlistItem(item.articleId)"
                  ></a>
                </figure>
                <div class="title-attributes">
                  <h2 class="product-title">
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: item.articleId, slug: slugify(item.title) }
                      }"
                    >
                      {{ item.title }}
                    </router-link>
                  </h2>
                  <!-- <p class="cart-attribut-title">
                    Boja: <span class="cart-attribut-value">crvena</span>
                  </p>
                  <p class="cart-attribut-title">
                    Veličina: <span class="cart-attribut-value">XL</span>
                  </p>
                  <p class="cart-attribut-title">
                    Obujam: <span class="cart-attribut-value">5 Litara</span>
                  </p> -->
                </div>
              </td>
              <td>{{ item.code }}</td>
              <td v-if="canViewPrices">
                <div>
                  <span
                    class="text-primary price-discount"
                    v-if="profile.discountDataVisible && item.salePrice"
                  >
                    ({{ item.saleDiscountPercentage | percentage }}%)
                  </span>

                  <span
                    class="text-primary price-discount"
                    v-if="
                      // eslint-disable-next-line max-len
                      profile.discountDataVisible && !item.salePrice && item.price < item.baseArticlePrice
                    "
                  >
                    {{ (100 - item.price / item.baseArticlePrice * 100).toFixed(2) }}
                  </span>
                  <span
                    class="product-price"
                    v-if="item.salePrice"
                  >
                    {{ item.salePrice | money3WithCurrency }}
                  </span>

                  <span
                    class="product-price"
                    v-if="!item.salePrice"
                  >
                    {{ item.price | money3WithCurrency }}
                  </span>
                  <span
                    class="old-price"
                    v-if="item.salePrice && item.salePrice < item.price"
                  >
                    <del> {{ item.price  | money3  }} KM</del>
                  </span>

                  <span
                    class="old-price"
                    v-if="!item.salePrice && item.price < item.baseArticlePrice"
                  >
                    <del> {{ item.baseArticlePrice  | money3  }} KM</del>
                  </span>
                </div>
              </td>
              <td class="action">
                <button
                  class="btn btn-quickview mt-1 mt-md-0"
                  @click.stop="getQuickArticle(item.articleId)"
                >
                  {{ translations.quickPreview }}
                </button>
                <button
                  @click="addToCart(item.articleId)"
                  class="btn btn-primary btn-add-cart product-type-simple btn-shop"
                >
                  {{ translations.addToCart }}
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="4" class="clearfix">
                <div class="float-left">
                  <router-link exact :to="{ name: 'Home' }" class="btn btn-outline-secondary">
                    {{ translations.continueShopping }}
                  </router-link>
                </div>
                <!-- End .float-left -->
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="cart-table wishlist-table-container" v-else>
        <div class="alert alert-info">
          Vaša lista želja je prazna
        </div>
      </div>
      <!-- End .cart-table-container -->
    </div>
    <!-- End .container -->
  </div>
</template>

<script>
import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';

import Photo from '@/components/shared/Image.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';
import { translations } from '@/mixins';

export default {
  name: 'WishList',
  mixins: [translations],
  components: {
    QuickPreview,
    Photo,
    Modal,
  },
  computed: {
    wishlist() {
      return this.$store.getters.getWishlist;
    },
    baseUrl() {
      return config.baseUrl;
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  methods: {
    slugify,
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getWishList');
      });
    },
    addToCart(articleId) {
      // if (this.attributeCombinations.length !== this.article.articleAttributes.length) {
      //   this.$toast.error('Morate izabrati sve kombinacije');
      //   return;
      // }
      api
        .addToShoppingCart({
          articleId,
          quantity: 1,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getShoppingCart');
        }).catch((err) => {
          this.$toast.error(err.response.data.info);
          this.$store.dispatch('getShoppingCart');
          $('#addCartModal').modal('hide');
        });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        $('#quick-preview-article').modal('show');
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};
</script>
<style lang="scss" scoped>
.btn-remove {
  cursor: pointer;

  &:hover {
    color: #1e84bc !important;
  }
}
</style>
